/* This view shows an overview of the book club, like the current book, the member's 
   reading progress statuses, and has a collective "noteboard" where you can post notes. */
import { BookOpen, Calendar, TrendingUp } from "lucide-react";
import NotesBoard from "../../components/notesBoard.jsx";
import { useState } from "react";
import { ProfileImg } from "../../components/ProfileIMG.jsx";
import { sortMembersByProgress } from "../../utils.js";

   
   export function OverviewTabView(props){
      const members_copy = [...props.members];
      const [progressInput, setProgressInput] = useState("");

      function memberStatusCB(member){
         console.log(member)

         const progressPercentage = member.readingProgress / props.currentBook.pages;

         return <div  key={member.userId}>
            {/* Profile pic and member name */}
            <div className="flex items-center gap-3">
                  <ProfileImg svgString={member.profileImg}/>
               <div className="flex-1">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-1">
                     <span className="text-amber-900">
                        {member.name}
                     </span >
                     <span className="text-amber-600">
                        {member.readingProgress} / {props.currentBook.pages} pages
                     </span>
                  </div>
               </div>
            </div>

            {/* Progress bar */}
            <div className="w-full h-2 bg-amber-100 rounded-full overflow-hidden mt-2">
               <div 
                  className="h-full bg-gradient-to-r from-amber-500 to-orange-600" 
                  style={{ width:`${progressPercentage*100}%`}}>
               </div>
            </div>
            
         </div>
      }

      function inputPageACB(evt){
         setProgressInput(evt.target.value);
      }

      function handleEnterPressACB(evt){
         evt.preventDefault(); // förhindrar reload
         const pages = Number(progressInput);
         const userId = props.currentUser.userId;
         props.onSetPage(pages, userId);
         setProgressInput("");
      }

      console.log(props.currentUser.readingProgress)
      //console.log("sending clubId", props.clubId);
      console.log("get noteboard",props.noteBoard);
      return <div className="space-y-6">
         {/*Current book*/}
         {props.currentBook ? (
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 !border border-amber-200">
               <div className="flex flex-col md:flex-row gap-6 items-start">
                   <img
                     src={props.currentBook.bookImg}
                     alt={props.currentBook.title}
                     className="mx-auto w-auto max-w-[80%] max-h-[200px] md:w-32 md:h-48 object-cover rounded-lg shadow-lg"
                  />
                  <div className="flex-1 min-w-0">
                     <h2 className="text-amber-900 mb-1">Currently Reading</h2>
                     <h3 className="text-amber-900 mb-1">{props.currentBook.title}</h3>
                     <div className="flex items-center gap-4">
                        <p className="bg-amber-100 px-2 py-1 rounded text-amber-700 mb-4">By: {props.currentBook.author}</p>
                        <p className="bg-amber-100 px-2 py-1 rounded text-amber-700 mb-4">{props.currentBook.genre}</p>
                     </div>

                     {/* Pages and deadline */}
                     <div className="space-y-2 mb-4">
                        <div className="">
                           <BookOpen className=" text-amber-700 w-4 h-4"/>
                           <span>{props.currentBook.pages} pages</span>
                        </div>
                        {props.deadline && (
                           <div className="flex items-center gap-2 text-amber-700">
                              <Calendar className="w-4 h-4"/>
                              <span>Deadline: {props.deadline}</span>
                           </div>
                        )}
                     </div>
                     
                     {/*Update progress*/}
                     <div className="bg-white rounded-lg p-4 !border border-amber-200">
                        <label className="block text-amber-900 mb-2">Update Your Progress</label>    
                           <form onSubmit={handleEnterPressACB} className="flex flex-col sm:flex-row gap-2">
                              <input 
                              type="number"
                              min="0"
                              max={props.currentBook.pages}
                              value={progressInput}
                              onChange={inputPageACB}
                              className="flex-1 px-4 py-2 !border border-amber-200 !rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"
                              placeholder="Current page"
                              />
                              <button 
                                 type="submit"
                                 className="px-4 py-2 bg-amber-600 text-white !rounded-lg hover:bg-amber-700 transition-colors">
                              Update
                              </button>
                           </form>
                        <div className="mt-3">
                           <div className="flex items-center justify-between mb-1">
                              <span className="text-amber-700">Your Progress</span>
                              <span className="text-amber-900">
                                 {props.currentUser.readingProgress || 0} / {props.currentBook.pages}
                              </span>
                           </div>
                           <div className="w-full h-3 bg-amber-100 rounded-full overflow-hidden">
                              <div 
                                 className="h-full bg-gradient-to-r from-amber-500 to-orange-600 transition-all duration-300"
                                 style={{ width:`${(props.currentUser.readingProgress / props.currentBook.pages)*100}%`}}>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

            </div>

         ) 
         : (<div className="bg-amber-50 rounded-xl p-8 !border border-amber-200 text-center">
            <BookOpen className="w-16 h-16 text-amber-300 mx-auto mb-4" />
            <h3 className="text-amber-900 mb-2">No Current Book</h3>
            <p className="text-amber-700">Visit the Suggestions tab to vote for the next book!</p>
            </div>)}

         {/* Member Progress Overview */}
         {props.currentBook && (
            <div className="bg-white rounded-xl p-6 !border border-amber-200">
               <div className="flex items-center gap-2 mb-4">
                  <TrendingUp className="w-5 h-5 text-amber-600 relative -translate-y-1" />
                  <h3 className="text-amber-900">Member Progress</h3>
               </div>

               {/* Mapping the members (array) reading statuses */}
               <div className="space-y-3">
                  {sortMembersByProgress(members_copy.filter(member => member != null)).map(memberStatusCB)}
               </div>
            </div>
         )}

         {/* Noteboard */}
         <div>
            <NotesBoard notes={props.noteBoard} currentUser={props.currentUser} clubId={props.clubId} onAddNote={props.onAddNote} onRemoveNote={props.onRemoveNote}/>
         </div>
         
      </div>

    
   }

         